__turbopack_context__.v({
  "flavorText": "S_GMHG_flavorText",
});
